module.exports = __webpack_public_path__ + "static/img/femLogo.8044e25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/femLogo.png
// module id = 5kEa
// module chunks = 6